<script setup lang="ts">
import { useToastsStore } from "@/stores/toasts";

const toasts = useToastsStore();
</script>

<template>
  <Teleport to="body">
    <div class="toast-tray" aria-live="polite">
      <div
        v-for="t in toasts.list"
        :key="t.id"
        class="toast"
        :data-level="t.level"
        @click="toasts.dismiss(t.id)"
      >
        {{ t.text }}
      </div>
    </div>
  </Teleport>
</template>

<style>
.toast-tray {
  position: fixed;
  bottom: 1.25rem;
  right: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  z-index: 2000;
  max-width: 420px;
}
.toast {
  background: #1f2937;
  color: #f9fafb;
  padding: 0.6rem 0.9rem;
  border-radius: 6px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  font-size: 0.85rem;
  border-left: 3px solid #4b5563;
}
.toast[data-level="success"] { border-left-color: #16a34a; }
.toast[data-level="error"]   { border-left-color: #dc2626; }
.toast[data-level="info"]    { border-left-color: #2563eb; }
</style>
